import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.string
};

function FormError(props) {
    return (
        <p className="bgorange font-weight-bold px-4 py-3 text-white" dangerouslySetInnerHTML={{ __html: props.children }}></p>
    );
}

FormError.propTypes = propTypes;

export default FormError;
